import React from 'react';
import PropTypes from 'prop-types';

import {useSelector} from 'react-redux'
import Cart from './UserCart'
import UserMenu from './UserMenu'
import NavLanguage from "./NavLanguage";

const UserNavComponent = ({ type, member, membershipInfo, brandName, dispatch, closeNavMenu }) => {
  const cart = useSelector(state => state.sandos4U.cart);
  const totalCart = cart ? cart.products.length : 0;
  const isMember = !!member;
  return (
    <div

    className={`flex items-start ${member?.memberShipName ? `member-${member?.memberShipName?.toLowerCase()}` : ''}`}>
      <Cart
        totalCart={totalCart}
        brandName={brandName}
        isMember={isMember}
        closeNavMenu={closeNavMenu}
      />
      <UserMenu
        type={type}
        member={member}
        membershipInfo={membershipInfo}
        isMember={isMember}
        dispatch={dispatch}
        closeNavMenu={closeNavMenu}
      />

    </div>
  )
};

UserNavComponent.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  loy3Member: PropTypes.object,
  brandName: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

UserNavComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default UserNavComponent;
